import Driver from 'driver.js';

let isActive = false;

function checkBeforeShow() {
  if (isActive) {
    console.log('Has another guide is active');
    return false;
  }
  if (document.body.clientWidth < 800) {
    console.log('Mobile view', document.body.clientWidth);
    return false;
  }

  isActive = true;

  return true;
}

export function showSingleStep(step, done) {
  if (!checkBeforeShow()) return;

  const driver = new Driver({
    allowClose: false,
    className: 'single-step-guide',
    closeBtnText: 'Đã hiểu',
    onReset: () => {
      isActive = false;
      done();
    },
  });
  driver.defineSteps([step, step]);
  driver.start();
}

export function showMultipleSteps(steps, done) {
  if (!checkBeforeShow()) return;

  const driver = new Driver({
    allowClose: false,
    // overlayClickNext: true,
    doneBtnText: 'Hoàn thành',
    closeBtnText: 'Bỏ qua',
    nextBtnText: 'Tiếp tục',
    prevBtnText: 'Quay lại',
    className: 'multiple-steps-guide',
    onReset: () => {
      isActive = false;
      done();
    },
  });

  driver.defineSteps(steps);
  driver.start();
}



// WEBPACK FOOTER //
// ./src/utils/tour.js